/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MatchVideoModelDto } from '../../models/match-video-model-dto';

export interface MatchVideoControllerCreateMatchVideo$Params {
      body: MatchVideoModelDto
}

export function matchVideoControllerCreateMatchVideo(http: HttpClient, rootUrl: string, params: MatchVideoControllerCreateMatchVideo$Params, context?: HttpContext): Observable<StrictHttpResponse<MatchVideoModelDto>> {
  const rb = new RequestBuilder(rootUrl, matchVideoControllerCreateMatchVideo.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MatchVideoModelDto>;
    })
  );
}

matchVideoControllerCreateMatchVideo.PATH = '/match-videos';
